import kebabCase from "lodash/kebabCase";
import solarSystemV2ScenarioPaths from "./solar-system-v2-scenario-paths.js";
import spaceflightV2ScenarioPaths from "./spaceflight-v2-scenario-paths.js";
import exoplanetV2ScenarioPaths from "./exoplanet-v2-scenario-paths.js";
import exoplanetV2LegacySlugPaths from "./exoplanet-v2-legacy-slug-paths.js";
import choreographyV2ScenarioPaths from "./choreography-v2-scenario-paths.js";
import choreographyV2LegacySlugPaths from "./choreography-v2-legacy-slug-paths.js";
import miscV2ScenarioPaths from "./misc-v2-scenario-paths.js";

export const CREATE_SCENARIO_V2_HREF = "/version-2/scenarios/custom-scenario/";

const V2_SCENARIO_BASE_BY_TYPE: Record<string, string> = {
  Exoplanets: "/version-2/scenarios",
  "Solar System": "/version-2/scenarios/solar-system",
  Spaceflight: "/version-2/scenarios/spaceflight",
};

const V2_MISC_SCENARIO_HREF: Record<string, string> = {
  "Create New Gravity Simulation": CREATE_SCENARIO_V2_HREF,
};

const V2_SCENARIO_PATHS_BY_TYPE: Record<string, Record<string, string>> = {
  Exoplanets: exoplanetV2ScenarioPaths,
  "Solar System": solarSystemV2ScenarioPaths,
  Spaceflight: spaceflightV2ScenarioPaths,
};

export const getV2MigratedScenarioHref = (
  type: string,
  legacyScenarioName: string
): string | null => {
  const miscHref = V2_MISC_SCENARIO_HREF[legacyScenarioName];
  if (miscHref) {
    return miscHref;
  }

  if (type === "Misc") {
    const byName = choreographyV2ScenarioPaths[legacyScenarioName];
    if (byName) {
      return `/version-2/scenarios/${byName}/`;
    }

    const bySlug =
      choreographyV2LegacySlugPaths[kebabCase(legacyScenarioName)];
    if (bySlug) {
      return `/version-2/scenarios/${bySlug}/`;
    }

    const miscRelative = miscV2ScenarioPaths[legacyScenarioName];
    if (miscRelative) {
      return `/version-2/scenarios/${miscRelative}/`;
    }
  }

  if (type === "Exoplanets") {
    const byName = exoplanetV2ScenarioPaths[legacyScenarioName];
    if (byName) {
      return `/version-2/scenarios/${byName}/`;
    }

    const bySlug =
      exoplanetV2LegacySlugPaths[kebabCase(legacyScenarioName)];
    if (bySlug) {
      return `/version-2/scenarios/${bySlug}/`;
    }

    return null;
  }

  const relativePath = V2_SCENARIO_PATHS_BY_TYPE[type]?.[legacyScenarioName];
  const base = V2_SCENARIO_BASE_BY_TYPE[type];

  if (!relativePath || !base) {
    return null;
  }

  return `${base}/${relativePath}/`;
};

export const getScenarioMenuHref = (type: string, name: string): string => {
  const v2Href = getV2MigratedScenarioHref(type, name);
  if (v2Href) {
    return v2Href;
  }

  return `/${kebabCase(type)}/${kebabCase(name)}`;
};

export const isV2ScenarioMenuLink = (type: string, name: string): boolean =>
  getV2MigratedScenarioHref(type, name) !== null;
